<!-- 组件说明 -->
<template>
  <div class="joint" @click="toDetail(jointItem)">
    <span>{{ jointIndex + 1 }}</span>
    <span>
      <!-- {{ jointItem.projectName }} -->
      {{ jointItem.recUserProject }}
    </span>
    <!-- <span>{{ jointItem.roomName }}</span> -->
    <span>{{ jointItem.recUserRoomName }}</span>
    <!-- <span>{{ jointItem.identityType === 1 ? "业主" : "家属" }}</span> -->
    <span>{{ jointItem.recUserIdentityType === 1 ? "业主" : "家属" }}</span>
  </div>
</template>

<script>
export default {
  props: {
    jointItem: {
      type: Object,
    },
    jointIndex: {
      type: Number,
    },
    projectCode: {
      type: String,
    },
    categray: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    //审核详情页
    toDetail(jointItem) {
      let id = jointItem.id;
      this.$router.push({
        name: "auditDetail",
        query: {
          id: id,
          projectCode: this.projectCode,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.joint {
  width: 690px;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
  border-radius: 16px;
  margin-top: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
</style>
